module.exports = __webpack_public_path__ + "img/QRK-alt.15440804.svg";